import { Model } from '../../../shared/models/model.class';
import { TaskComment } from '../task-comment/task-comment.model';
import * as _ from 'lodash';
import {IssueType} from 'ng2-app/modules/task-management/models/workflow-task/issue-types.model';

export class Task extends Model<Task> {
  id: number;
  borrowerId: number;
  description: string;
  creatorUserId: number;
  completedByUserId: number;
  contract_request: any;
  completed: string | null;
  toRole: string;
  creatorName: string;
  creator_user: { first: string, last: string };
  created: Date | null;
  createdTimestamp: number;
  deleted: Date | null;
  modified: any;
  completedByName: string;
  parentTaskId: number;
  type: string;
  issueType: IssueType;
  fromRole: string;
  comment: string | null;
  task_comments: TaskComment[];
  deal: any;
  dealStatuses?: any;

  fillable() {
    return [
      'id',
      'description',
      'borrowerId',
      'completed',
      'contract_request',
      'creatorUserId',
      'completedByUserId',
      'creatorName',
      'created',
      'createdTimestamp',
      'parentTaskId',
      'type',
      'issueType',
      'toRole',
      'fromRole',
      'comment',
      'task_comments',
      'creator_user',
      'deal',
      'dealStatuses'
    ];
  }

  serializeable() {
    return _.without(this.fillable(), 'creatorName') &&  _.without(this.fillable(), 'task_comments');
  }
}
